// In-memory auth state + cross-tab sync
let accessToken: string | null = null;
let expiresAt = null;

const bc =
  typeof window !== 'undefined' && 'BroadcastChannel' in window
    ? new BroadcastChannel('auth')
    : null;

type Token = {
  accessToken: string;
  expiry: Date;
};

function stringifyToken(token: Token): string {
  return JSON.stringify(token, (_k, v) => (v instanceof Date ? v.toISOString() : v));
}

function parseToken(json: string): Token {
  const obj = JSON.parse(json, (_k, v) =>
    typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T.*Z$/.test(v) ? new Date(v) : v
  );

  // Make sure this is a valid object
  if (
    !obj ||
    typeof obj.accessToken !== 'string' ||
    !(obj.expiry instanceof Date) ||
    isNaN(obj.expiry.getTime())
  ) {
    throw new Error('Invalid Token');
  }

  return obj as Token;
}

export function getAuth() {
  const token = localStorage.getItem('token') ? parseToken(localStorage.getItem('token')) : null;

  return token;
}

export function setAuth(token: string, expiry: Date) {
  const session = {
    accessToken: token,
    expiry: expiry,
  };

  const tokenStringified = stringifyToken(session);

  localStorage.setItem('token', tokenStringified);

  accessToken = token;
  expiresAt = expiry;
  bc?.postMessage({ type: 'token', token, expiry });
}

export function clearAuth() {
  localStorage.removeItem('token');
  accessToken = null;
  expiresAt = null;
  bc?.postMessage({ type: 'logout' });
}

export function getAccessToken() {
  return accessToken;
}
export function getExpiresAt() {
  return expiresAt;
}

bc?.addEventListener('message', (e) => {
  const m = e.data;
  if (m?.type === 'token') {
    accessToken = m.token;
    expiresAt = m.expiry;
  }
  if (m?.type === 'logout') {
    accessToken = null;
    expiresAt = null;
  }
});
